import { jsx as _jsx } from "react/jsx-runtime";
import { PhoneNumberSelect } from './PhoneNumberSelect';
export const TopbarButtons = ({ extraData, isFlowActive, changeNumber, getNumbersByQuery, }) => {
    return (_jsx(PhoneNumberSelect, { changePhoneNumber: changeNumber, className: "flow-number-selector", disabled: isFlowActive, getPhoneNumbersByQuery: getNumbersByQuery, phoneNumber: extraData.number }));
};
